import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Textarea,
  VStack
} from '@chakra-ui/react'
import { AddEditTaskModalProps } from './types'

const AddEditTaskModal: React.FC<AddEditTaskModalProps> = ({
  editingTask,
  handleAddTask,
  handleEditTask,
  initialFocusRef,
  isEditing,
  isOpen,
  newTask,
  onClose,
  setEditingTask,
  setNewTask
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    initialFocusRef={initialFocusRef}
    isCentered
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        {isEditing ? 'Edit Task' : 'Create New Task'}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <VStack spacing={4}>
          <Input
            ref={initialFocusRef}
            placeholder="Task title"
            value={isEditing ? editingTask?.text : newTask.text}
            onChange={(e) => {
              if (isEditing && editingTask) {
                setEditingTask({ ...editingTask, text: e.target.value })
              } else {
                setNewTask({ ...newTask, text: e.target.value })
              }
            }}
          />
          <Textarea
            placeholder="Description (optional)"
            value={isEditing ? editingTask?.description : newTask.description}
            onChange={(e) => {
              if (isEditing && editingTask) {
                setEditingTask({ ...editingTask, description: e.target.value })
              } else {
                setNewTask({ ...newTask, description: e.target.value })
              }
            }}
            resize="vertical"
            rows={4}
          />
        </VStack>
      </ModalBody>

      <ModalFooter>
        <Button
          colorScheme="teal"
          mr={3}
          onClick={isEditing ? handleEditTask : handleAddTask}
        >
          {isEditing ? 'Save Changes' : 'Add Task'}
        </Button>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)

export default AddEditTaskModal